export const SIETE_SEND = 'SIETE_SEND'
export const SIETE_OUT = 'SIETE_OUT'
export const SIETE_ALL = 'SIETE_ALL'

export const ALL_DOCUMENTS = 'ALL_DOCUMENTS' 

export const SALDADO = 'SALDADO'
export const NO_SALDADO = 'NO_SALDADO'

export const ARMADO = 'ARMADO'
export const ENTREGADO = 'ENTREGADO'

export const APROBADO = 'APROBADO'
export const DESAPROBADO = 'DESAPROBADO'
